// extracted by mini-css-extract-plugin
export default {"progress":"progress__uzEkAt"};